var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-0 order-timer pos-primary-color"},[_c('b-icon',{attrs:{"icon":"clock"}}),_vm._v(" "+_vm._s(_vm.timeLeft)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }